<template>
    <ui-modal title="Update linked packages" :close="close">
        <ul class="space-y-4 mt-6">
            <li v-for="linkedPackage in form.packages" :key="linkedPackage.id" class="flex space-x-0.5">
                <a :href="linkedPackage._links.frontend.view"
                   class="px-3 py-1.5 rounded-l-lg text-gray-700 hover:text-gray-800 bg-gray-50 hover:bg-gray-100 flex-1">
                    <p v-text="linkedPackage.name"></p>
                    <p class="text-sm text-gray-500" v-text="linkedPackage.client"></p>
                </a>
                <button v-if="isConfirmingUnlinkPackage(linkedPackage)" @click="unlinkPackage(linkedPackage)"
                        class="px-3 py-1.5 rounded-r-lg bg-gray-50 flex text-gray-500 hover:bg-red-50 hover:text-red-500">
                    <p class="inline-block m-auto">Are you sure?</p>
                </button>
                <button v-else @click="confirmUnlinkPackage(linkedPackage)"
                        class="px-3 py-1.5 rounded-r-lg bg-gray-50 flex text-gray-400 hover:bg-red-50 hover:text-red-500">
                    <i class="fa fa-trash m-auto"></i>
                </button>
            </li>
        </ul>
        <ui-form-section class="mt-6">
            <ui-select-searchable
                label="Link a Package"
                placeholder="Search a new package to link..."
                :search="searchPackages"
                no-search="Start typing to find packages..."
                v-model="searchedPackage"
                @input="linkPackage"
            ></ui-select-searchable>
        </ui-form-section>
        <template #footer-primary>
            <ui-button-new primary class="w-full" :loading="form.busy" @click="form.submit()">Save</ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
import {Package} from '@models'

export default {
    props: {
        close: Function,
        packageItem: Object,
    },
    data() {
        const initialData = {
            packages: [...this.packageItem.linked],
        }

        return {
            searchedPackage: null,
            confirmingPackageToUnlink: null,
            form: new Form(initialData, async (form) => {
                const packages = form.packages.map(({id}) => id)
                await this.packageItem.updateLinkedPackages(packages)
                this.close()
            }),
        }
    },
    methods: {
        async searchPackages(query) {
            return await Package.search(query, true)
        },
        linkPackage(newPackage) {
            const {id, name, _links, client} = newPackage
            this.form.packages.push({id, name, _links, client: client ? client.name : ''})
            this.$nextTick(() => {
                this.searchedPackage = null
            })
        },
        isConfirmingUnlinkPackage(linkedPackage) {
            return this.confirmingPackageToUnlink?.id === linkedPackage.id
        },
        confirmUnlinkPackage(linkedPackage) {
            this.confirmingPackageToUnlink = linkedPackage
        },
        unlinkPackage(linkedPackage) {
            this.form.packages = this.form.packages.filter(({id}) => linkedPackage.id !== id)
            this.confirmingPackageToUnlink = null
        },
    },
    mounted() {
    }
}
</script>
